import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();
  
  // Si l'utilisateur est connecté et n'est pas déjà sur une page protégée
  if (token && !location.pathname.startsWith('/auth/')) {
    const userType =
      localStorage.getItem('userType') ||
      localStorage.getItem('userRole') ||
      'client';
    // Éviter la redirection si déjà sur le bon tableau de bord
    if (!location.pathname.startsWith(`/${userType}`)) {
      const targetPath = userType === 'admin' ? '/admin' : `/${userType}`;
      return <Navigate to={targetPath} replace />;
    }
  }
  
  // Si l'utilisateur n'est pas connecté ou est sur une page d'authentification
  return children;
};

export default PublicRoute;
 